export const TABS_VALUES = ['1', '2']
